/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { FC, Fragment } from "react";
import { Link, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { UICarrierBaggagePolicies } from "@flights/types";
import styles from "./BaggagePolicies.module.css";
import Frame from "../Frame";

type Props = {
  baggagePolicies: UICarrierBaggagePolicies[];
  customTitle?: string;
};

const BaggagePolicies: FC<Props> = ({ baggagePolicies, customTitle }) => {
  const i18n = useI18n();

  if (baggagePolicies.length === 0) {
    return null;
  }

  const defaultTitle =
    baggagePolicies.length === 1 ? t("flights_sr_baggage_policy_list_1") : t("flights_sr_baggage_policies_list");

  return (
    <Frame pt={1}>
      <Text variant="small_1" className={styles.title}>
        {customTitle || i18n.trans(defaultTitle)}
      </Text>

      {baggagePolicies.map((policy, i) => {
        let separator = "";
        const isLastOne = i === baggagePolicies.length - 1;

        if (!isLastOne && baggagePolicies.length > 1) {
          const isSecondToLastOne = i === baggagePolicies.length - 2;

          separator = i18n.trans(
            isSecondToLastOne ? t("flights_sr_airline_separator_last") : t("flights_sr_airline_separator")
          );
        }

        return (
          <Fragment key={policy.name + policy.url + i}>
            <Link
              className={styles.itemLink}
              text={policy.name}
              href={policy.url}
              attributes={{
                target: "_blank",
                rel: "noopener noreferrer",
                "aria-label": i18n.trans(
                  t("a11y_flights_sr_baggage_policy_link_hint", { variables: { airline_name: policy.name } })
                )
              }}
            />
            {separator}
          </Fragment>
        );
      })}
    </Frame>
  );
};

export default BaggagePolicies;
